import React from "react";
import { Button } from "react-bootstrap";

import moment from "moment";

import { translate, getLanguage } from "../Translation/Translation";

let cardDay = null;

class OSDayCard extends React.Component {
  componentWillReceiveProps(nextProps) {
    const { departurePortCode, arrivalPortCode } = nextProps.data.data.settings;
    cardDay = nextProps.tripDay.format("YYYY-MM-DD");
    if (departurePortCode !== "ALL" && arrivalPortCode !== "ALL") {
      if (nextProps.mode === "departure") {
        if (nextProps.data.data.itineraries.searchStartDay === cardDay) {
          if (
            nextProps.data.data.itineraries.userSelectedDepartureTrip === false
          ) {
            if (nextProps.trips.length > 0) {
              localStorage.setItem(
                "departureLocation",
                JSON.stringify(nextProps.trips[0].departureLocation)
              );
              localStorage.setItem(
                "arrivalLocation",
                JSON.stringify(nextProps.trips[0].arrivalLocation)
              );
              this.selectTrip(nextProps.trips[0], false);
            }
          }
        }
      }

      if (nextProps.mode === "arrival") {
        if (nextProps.data.data.itineraries.searchEndDay === cardDay) {
          if (
            nextProps.data.data.itineraries.userSelectedReturnTrip === false
          ) {
            if (nextProps.trips.length > 0) {
              localStorage.setItem(
                "departureLocation",
                JSON.stringify(nextProps.trips[0].departureLocation)
              );
              localStorage.setItem(
                "arrivalLocation",
                JSON.stringify(nextProps.trips[0].arrivalLocation)
              );
              this.selectTrip(nextProps.trips[0], false);
            }
          }
        }
      }
    }
  }

  selectTrip(trip, userSelectedTrip) {
    if (this.props.mode === "departure") {
      localStorage.setItem("outgoingTrip", JSON.stringify(trip));
      localStorage.setItem(
        "departureLocation",
        JSON.stringify(trip.departureLocation)
      );
      this.props.data.data.setSelectedOutgoingTrip(trip);
      if (userSelectedTrip) {
        this.props.data.data.setUserSelectedDepartureTrip(true);
      }
    } else {
      localStorage.setItem("incomingTrip", JSON.stringify(trip));
      localStorage.setItem(
        "arrivalLocation",
        JSON.stringify(trip.arrivalLocation)
      );
      this.props.data.data.setSelectedIncomingTrip(trip);
      if (userSelectedTrip) {
        this.props.data.data.setUserSelectedReturnTrip(true);
      }
    }
  }

  render() {
    const tripRows = this.props.trips.map((trip, index) => {
      let SELECTED_CLASS = "";
      if (
        trip === this.props.data.data.itineraries.selectedIncomingTrip ||
        trip === this.props.data.data.itineraries.selectedOutgoingTrip
      ) {
        SELECTED_CLASS = "selected_trip";
      }
      return (
        <div
          style={{ textAlign: "center", cursor: "pointer" }}
          className={`OSDayCardTripContainerCompanyRow ${SELECTED_CLASS}`}
          key={`${trip.departureDateTime}-${trip.vessel.code}-${index}`}
          onClick={event => this.selectTrip(trip, true)}
        >
          <div
            className="OSDayCardTripContainerCompanyImage"
            style={{
              backgroundImage: `url(${trip.company.imageUrl})`,
              backgroundPosition: "left",
              backgroundSize: "cover"
            }}
          />
          <div className="OSDayCardTripCompanyName">{trip.vessel.name}</div>
          <div className="OSDayCardTripTimes">
            {moment(trip.departureDateTime, "YYYY-MM-DD HH:mm:SS").format(
              "HH:mm"
            )}
            <div className="timeArrow">
              <svg
                viewBox="0 0 1000 1000"
                className="DateRangePickerInput_arrow_svg DateRangePickerInput_arrow_svg_1"
              >
                <path d="M694.4 242.4l249.1 249.1c11 11 11 21 0 32L694.4 772.7c-5 5-10 7-16 7s-11-2-16-7c-11-11-11-21 0-32l210.1-210.1H67.1c-13 0-23-10-23-23s10-23 23-23h805.4L662.4 274.5c-21-21.1 11-53.1 32-32.1z" />
              </svg>
            </div>
            {moment(trip.arrivalDateTime, "YYYY-MM-DD HH:mm:SS").format(
              "HH:mm"
            )}
          </div>

          <div style={{ textAlign: "center" }}>
            <Button
              style={{ position: "relative", marginRight: "0" }}
              className={`selectButton ${SELECTED_CLASS}`}
              loading={this.props.isloading}
              onClick={event => this.selectTrip(trip, true)}
            >
              {!(
                trip ===
                  this.props.data.data.itineraries.selectedIncomingTrip ||
                trip === this.props.data.data.itineraries.selectedOutgoingTrip
              )
                ? translate(getLanguage(), "Select")
                : translate(getLanguage(), "Selected")}
            </Button>
          </div>
        </div>
      );
    });
    return (
      <div className="OSDayCardContainer">
        <div className="OSDayCardDay">{this.props.tripDay.format("dddd")}</div>
        <div className="OSDayCardTripContainer ">
          <div className="OSDayTripContainerDay">
            {this.props.tripDay.format("D MMM")}
          </div>
          {tripRows}
        </div>
      </div>
    );
  }
}

export default OSDayCard;



// WEBPACK FOOTER //
// ./src/components/OSDayCard/OSDayCard.js